<template>

  <svg
    t="1631089054726"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5225"
    width="64"
    height="64"
  ><path d="M254.176 480c17.792 0 32.224 14.336 32.224 32 0 16.416-12.448 29.952-28.48 31.776L254.176 544h-69.76l-52.768 288h760.704l-52.736-288h-69.792a32.128 32.128 0 0 1-32.224-32c0-16.416 12.416-29.952 28.48-31.776l3.744-0.224h69.76c29.44 0 54.88 19.744 62.304 47.552l1.12 4.992 56.192 306.88a48 48 0 0 1-38.912 55.808l-4.288 0.576-4.352 0.192H112.352C85.632 896 64 874.496 64 848l0.192-4.32 0.576-4.256 56.192-306.88a64.32 64.32 0 0 1 58.272-52.352L184.384 480h69.76zM512 128a224 224 0 0 1 224 224c0 73.856-59.904 175.68-179.712 305.504l-21.664 23.104-0.544 0.544a32 32 0 0 1-42.304 1.6l-2.944-2.72-10.72-11.328C351.392 533.536 288 427.968 288 352a224 224 0 0 1 224-224z m0 64a160 160 0 0 0-160 160c0 51.2 49.216 136.576 150.368 248.544l9.6 10.56 9.664-10.56C622.72 488.576 672 403.328 672 352a160 160 0 0 0-160-160z m0 96a64 64 0 1 1 0 128 64 64 0 0 1 0-128z" p-id="5226" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMap',
} as DefineComponent
</script>